import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { getNotificationSeen } from "redux/actions/UserNotification";
import store from "redux/store";
import { GET_NOTIFICATIONCOUNT_FAILED, GET_NOTIFICATIONCOUNT_REQUESTED, GET_NOTIFICATIONCOUNT_SUCCESS, GET_NOTIFICATIONSEEN_FAILED, GET_NOTIFICATIONSEEN_REQUESTED, GET_NOTIFICATIONSEEN_SUCCESS, GET_NOTIFICATION_FAILED, GET_NOTIFICATION_REQUESTED, GET_NOTIFICATION_SUCCESS } from "resources/actionTypes";
import { notificationApi, notificationCountApi, notificationSeenApi } from "services/NotificationService";

function* fetchNotification(action) {
  try {
    const payload = action.payload || {}
    const userNotification = yield call(notificationApi,payload);
    yield put({ type: GET_NOTIFICATION_SUCCESS, userNotification: userNotification });
    if(userNotification.success){
      store.dispatch(getNotificationSeen({id:""}));
    }
  } catch (e) {
    yield put({ type: GET_NOTIFICATION_FAILED, message: e.message });
    toast.error(e.message || 'Get Notification Failed')
  }
}

export function* notificationSaga() {
  yield takeEvery(GET_NOTIFICATION_REQUESTED, fetchNotification);
}

function* fetchNotificationCount(action) {
  try {
    const payload = action.payload || {}
    const userNotificationCount = yield call(notificationCountApi,payload);
    yield put({ type: GET_NOTIFICATIONCOUNT_SUCCESS, userNotificationCount: userNotificationCount });
  } catch (e) {
    yield put({ type: GET_NOTIFICATIONCOUNT_FAILED, message: e.message });
    toast.error(e.message || 'Get NotificationCount Failed')
  }
}

export function* notificationCountSaga() {
  yield takeEvery(GET_NOTIFICATIONCOUNT_REQUESTED, fetchNotificationCount);
}

function* fetchNotificationSeen(action) {
  try {
    const payload = action.payload || {}
    const userNotificationSeen = yield call(notificationSeenApi,payload);
    yield put({ type: GET_NOTIFICATIONSEEN_SUCCESS, userNotificationSeen: userNotificationSeen });
  } catch (e) {
    yield put({ type: GET_NOTIFICATIONSEEN_FAILED, message: e.message });
    toast.error(e.message || 'Get Notification Seen Failed')
  }
}

export function* notificationSeenSaga() {
  yield takeEvery(GET_NOTIFICATIONSEEN_REQUESTED, fetchNotificationSeen);
}